// src/components/about/SustainabilitySection.js
import React, { useEffect, useRef } from 'react';
import { fadeIn } from '../../utils/gsapAnimations';

function SustainabilitySection({ content }) {
  const sectionRef = useRef(null);

  useEffect(() => {
    fadeIn(sectionRef.current, 0.3);
  }, []);

  return (
    <section ref={sectionRef} className="py-12">
      <h2 className="text-2xl font-playfair-display font-semibold text-primary mb-6 text-center">
        {content?.title || 'Our Commitment to Sustainability'}
      </h2>
      <div className="flex flex-col md:flex-row-reverse items-center gap-8">
        <img
          src={content?.image || '/assets/images/about-sustainability.jpg'}
          alt={content?.imageAlt || 'Sustainability'}
          className="w-full md:w-1/2 h-64 object-cover rounded-lg"
          loading="lazy"
        />
        <p className="font-montserrat text-primary">
          {content?.description ||
            'At MyShop, sustainability is at our core. We use organic cotton, recycled materials, and ethical production processes to create clothing that’s kind to the planet. Our goal is to lead the fashion industry toward a greener future, one garment at a time.'}
        </p>
      </div>
    </section>
  );
}

export default SustainabilitySection;